'use client'

import { DetailedHTMLProps, ImgHTMLAttributes } from "react";

interface Props extends DetailedHTMLProps<ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement> {
    src: string;
    alt: string;
    fallback: string;
}

export const Image = ({src, fallback, alt, ...rest}: Props) => {
    return <div>
        <img onError={(ev: any) => {
            console.error('fallback image src:', src, 'fallback:', fallback)
            // ev.target.src = fallback
            ev.currentTarget.onerror = null; // prevents looping
            ev.currentTarget.src = fallback
            ev.target.onerror = null;
        }}  {...rest} src={src? src : fallback} alt={alt} />
    </div>
}